import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { projectPagesMap } from '../../constants';
import { ProjectStepAction } from '../../interfaces';

import { AccessGuard } from '../AccessGuard/AccessGuard';
import { ValuesPage } from './Pages/ValuesPage/ValuesPage';
import { EtlPage } from './Pages/ETL/EtlPage';
import { TemplatesPage } from './Pages/Templates/TemplatesPage';
import { QueryEditPage } from './Pages/QueryEditPage/QueryEditPage';
import { WorkspaceSettingsPage } from './Pages/WorkspaceSettings/WorkspaceSettings';
import { DataPage } from './Pages/Data/DataPage';
import { BlocksPage } from './Pages/Blocks/BlocksPage';

import DocumentsPage from '../../subPages/Documents/DocumentsPage';
import EntitiesPage from '../../subPages/Entities/EntitiesPage';
interface Props {
  isLoading: boolean;
  slug?: string;
  projectData: any;
  grants: any;
  projectSideNavItems: ProjectSideNavItem[];
  onAction: (action: ProjectStepAction) => void;
}

export const RenderWorkspacePage: FC<Props> = ({
  isLoading,
  projectData,
  grants,
  projectSideNavItems,
  onAction,
}) => {
  const { slug } = useParams();

  const currentSideNavItem = (projectSideNavItems || []).find((item) => item.slug === slug);

  switch (slug) {
    case projectPagesMap.TEMPLATES.slug:
      return <TemplatesPage workspaceData={projectData} slug={projectPagesMap.TEMPLATES.slug} isLoading={isLoading} />;

    case projectPagesMap.ETL.slug:
      return <EtlPage workspaceData={projectData} onAction={onAction} isLoading={isLoading} />;

    case projectPagesMap.VALUES.slug:
      return <ValuesPage key={slug} projectData={projectData} onAction={onAction} isLoading={isLoading} />;

    case projectPagesMap.DATA.slug:
      return <DataPage key={slug} projectData={projectData} grants={grants} isLoading={isLoading} />;
    // return <QueryPage key={slug} projectData={projectData} isLoading={isLoading} />;

    case projectPagesMap.QUERIES.slug:
      return <QueryEditPage workspaceData={projectData} isLoading={isLoading} />;

    case projectPagesMap.WORKSPACE_SETTINGS.slug:
      return <WorkspaceSettingsPage workspaceData={projectData} isLoading={isLoading} />;
    case projectPagesMap.BLOCKS.slug:
      return <BlocksPage workspaceData={projectData} isLoading={isLoading} />;

    case projectPagesMap.DOCUMENTS.slug:
    case projectPagesMap.UPLOADED_DATA.slug:
      return (
        <AccessGuard allowedRoles={currentSideNavItem?.accessRoles} accessRole={grants?.role}>
          <DocumentsPage
            key={slug}
            rootFolderId={
              slug === projectPagesMap.DOCUMENTS.slug
                ? projectData?.DocumentsFolderID
                : projectData?.UploadedDataFolderID
            }
          />
        </AccessGuard>
      );

    case projectPagesMap.ENTITIES.slug:
      return <EntitiesPage projectData={projectData} isLoading={isLoading} />;

    default:
      return <div>Unsupported page type</div>;
  }
};
